import React from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import LanguageToggle from './LanguageToggle';
import AppMenuBar from './AppMenuBar';
import { useSubscription } from '../context/SubscriptionContext';
import { getEnabledGameCount } from '../services/GameAvailability';

const GlobalControls = () => {
    const { user, isGuest, hasPlayerSession, initializing } = useAuth();
    const { feature } = useSubscription();
    const { pathname } = useLocation();
    if (initializing || pathname.startsWith('/play/')) return null;
    const isAuthPage = ['/login', '/register', '/forgot-password'].includes(pathname);
    const showAccountMenu = Boolean(hasPlayerSession || user || isGuest) && !isAuthPage;
    const isLobbyPath = /^\/poker(?:\/[^/]+)?\/?$/.test(pathname) || /^\/shan9mee(?:\/[^/]+)?\/?$/.test(pathname)
        || /^\/\d{4,12}\/?$/.test(pathname);
    const isLobby = isLobbyPath && getEnabledGameCount(feature) > 1;
    return <AppMenuBar isLobby={isLobby} menuControl={showAccountMenu ? undefined : <LanguageToggle />} />;
};
export default GlobalControls;
